module.exports = __webpack_public_path__ + "Лев.890adf0.png";